module.exports = __webpack_public_path__ + "img/10.da12b659.jpg";